// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
/**
 * Election events, elections, contests and candidates keep their translated
 * names in `presentation` and their former alias in `external_id` (migration
 * 1772358027729), so the search matches either.
 */
export function electionSearchQuery(searchText) {
    var text = searchText.trim();
    if (!text)
        return undefined;
    var pattern = "%".concat(text, "%");
    return {
        format: "hasura-raw-query",
        text: searchText,
        value: [
            { external_id: { _ilike: pattern } },
            { presentation: { _cast: { String: { _ilike: pattern } } } },
        ],
    };
}
/** The text of an election search, for the filter input that set it. */
export var electionSearchText = function (query) { var _a; return (_a = query === null || query === void 0 ? void 0 : query.text) !== null && _a !== void 0 ? _a : ""; };
/** The react-admin filter of an election autocomplete. */
export function electionSearchFilter(searchText) {
    var query = electionSearchQuery(searchText);
    return query ? { _or: query } : {};
}
